module.exports = __webpack_public_path__ + "static/media/june_2025_3.8102dcdd.webp";